import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import toggle from '../../assets/toggle.svg'
import DROPDOWN_TAIL from '../../assets/dropdown-tail.svg'
import { TOGGLE_STATE, UPDATE_CURRENT_LANGUAGE } from '../../constants/actionTypes'
import logo from '../../assets/aakashlogo-white.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'

const mapStateToProps = (state) => {
    return {
        completion: state.completion,
        time_completion: state.t,
        toggle: state.toggleStatus,
        ...state.instructions,
        ...state.timer,
        ...state,
    }
}

const mapDispatchToProps = (dispatch) => ({
    setToggle: (payload) => {
        dispatch({ type: TOGGLE_STATE, payload })
    },
    updateCurrentLanguage: (payload) => {
        dispatch({ type: UPDATE_CURRENT_LANGUAGE, payload })
    },
})

const HeaderTitleDropdown = ({ selectLanguage, ...props }) => {
    const { t, i18n } = useTranslation()
    const location = useLocation()
    const wrapperRef = useRef(null)
    const [dropdown, setDropdown] = useState(false)
    const [showDropdown, setShowDropdown] = useState(false)
    const [showInfoTag, setShowInfoTag] = useState(
        location.pathname === '/' ? true : false,
    )
    const [lngSupport, setLngSupport] = useState([])

    useEffect(() => {
        setTimeout(() => {
            setShowInfoTag(false)
        }, 10000)
    }, [])

    useEffect(() => {
        document.addEventListener('mousedown', (e) => handleClickOutside(e))

        if (location.pathname === '/testpanel') {
            if (props.testData) {
                const availableLanguages = props.testData?.language?.split(',')

                if (
                    availableLanguages &&
                    !availableLanguages.includes(props.current_language)
                ) {
                    props.updateCurrentLanguage(
                        availableLanguages.length ? availableLanguages[0] : 'en',
                    )
                    i18n.changeLanguage(
                        availableLanguages.length ? availableLanguages[0] : 'en',
                    )
                }

                availableLanguages && setLngSupport(availableLanguages)
            }
        } else {
            if (props.instructions?.testData) {
                const availableLanguages =
                    props.instructions?.testData?.instruction?.language?.split(',')

                if (
                    availableLanguages &&
                    !availableLanguages.includes(props.current_language)
                ) {
                    props.updateCurrentLanguage(
                        availableLanguages.length ? availableLanguages[0] : 'en',
                    )
                    i18n.changeLanguage(
                        availableLanguages.length ? availableLanguages[0] : 'en',
                    )
                }

                availableLanguages && setLngSupport(availableLanguages)
            }
        }
    }, [
        props.calculated_time_left,
        props.instructions.testData ? props.instructions.testData.language : null,
    ])

    useEffect(() => {
        if (location.pathname === '/') {
            i18n.changeLanguage(props.current_language)
            setShowDropdown(true)
        } else {
            setShowDropdown(false)
        }
    }, [location])

    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setDropdown(false)
        }
    }

    const handleLangDropdownClick = () => {
        setShowInfoTag(false)
        setDropdown((dropdown) => !dropdown)
    }

    const togglerState = (e) => {
        e.stopPropagation()

        if (props?.toggle?.toggle) {
            props?.setToggle(false)
        } else {
            props?.setToggle(true)
        }
    }

    const handleLangSelection = (e, item) => {
        props.handleLangChange(e, selectLanguage(item))
        setDropdown((dropdown) => !dropdown)
    }

    return (
        <div className="header_div">
            <div className="header-title-wrapper">
                <img className="icon" src={logo} />
                <div className="title-toggle-wrapper">
                    {props.testData ? (
                        <div role="heading" className="header-title">
                            {props.testData?.title
                                ? props.testData?.title[i18n.language]
                                : null}
                        </div>
                    ) : (
                        <div className="header-title"></div>
                    )}
                    <div className="toggle-icon">
                        {props?.showToggle ? (
                            <img
                                className="toggle-panel"
                                id="side_bar"
                                src={toggle}
                                onClick={togglerState}
                            ></img>
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {showDropdown && lngSupport.length > 1 ? (
                    <div
                        className={`dropdown-wrapper ${dropdown ? 'active' : ''}`}
                        value={i18n.language}
                        ref={wrapperRef}
                    >
                        <p className="dropdown-label">Test language</p>
                        <button
                            // role="checkbox"
                            // aria-checked="false"
                            /* role="button" */
                            className="dropdown-heading"
                            onClick={handleLangDropdownClick}
                        >
                            <div>
                                <span className="icon-drop">
                                    {dropdown ? (
                                        <FontAwesomeIcon icon={faChevronUp} />
                                    ) : (
                                        <FontAwesomeIcon icon={faChevronDown} />
                                    )}
                                </span>
                                {selectLanguage(i18n.language)}
                            </div>

                            {showInfoTag ? (
                                <div className="dropdown-info-tag-wrapper">
                                    <div className="dropdown-info-tag">
                                        <img
                                            src={DROPDOWN_TAIL}
                                            className="dropdown-info-tag-tail"
                                            alt="tail"
                                        />
                                        <p className="dropdown-info-tag-header">
                                            Preferred test language
                                        </p>
                                        <p className="dropdown-info-tag-text">
                                            Click here to select preferred test
                                            language
                                        </p>
                                        <p
                                            className="dropdown-info-tag-button"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                setShowInfoTag(false)
                                            }}
                                        >
                                            Got it
                                        </p>
                                    </div>
                                </div>
                            ) : null}
                        </button>
                        <div className="icon-wrapper">
                            <div className="dropdown-content">
                                <ul>
                                    {lngSupport.map((item, index) => {
                                        return (
                                            <li key={`${item}-${index}`}>
                                                <input
                                                    type="radio"
                                                    name="test"
                                                    id={index}
                                                    value={item}
                                                    checked={
                                                        i18n.language === item
                                                            ? 'checked'
                                                            : ''
                                                    }
                                                    onChange={(e) =>
                                                        handleLangSelection(e, item)
                                                    }
                                                />
                                                <label
                                                    // role="radio"
                                                    htmlFor={index.toString()}
                                                >
                                                    {selectLanguage(item)}
                                                </label>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderTitleDropdown)
